// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import { color } from '../../../styles/theme';
import dayjs from 'dayjs';
import SearchAddressForm from '../../common/SearchAddressForm';

export default class FormView extends JQueryView {
  holderType: string;
  isOverseas: boolean;
  hasChangedResidence: boolean;
  establishAt: string;
  formDisabled: boolean;
  disabledHolderType: boolean;
  searchAddress: Object;

  constructor(
    holderType: string,
    isOverseas: boolean,
    establishAt: string,
    formDisabled: boolean,
    disabledHolderType: boolean,
  ) {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.holderType = holderType;
    this.isOverseas = isOverseas;
    this.hasChangedResidence = false;
    this.establishAt = establishAt;
    this.formDisabled = formDisabled;
    this.disabledHolderType = disabledHolderType;
    this.initDateRangePicker(this.$el);
    this.initExecutionOnDateRangePicker($('.right-type-modal .execution_on'));
    this.renderAddressArea();
    this.renderPersonalArea();
    this.renderStaffArea();
    this.renderAlternativeArea();
    if (this.disabledHolderType) {
      this.renderDisabledHolderType();
    }
    if (this.formDisabled) {
      this.renderDisabled();
    }
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs().toDate(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  initExecutionOnDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs()
          .add(50, 'year')
          .toDate(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    event.preventDefault();
    $(event.target) // 保有新株予約権の削除用
      .parent()
      .prev('input[type=hidden]')
      .val('1');
    $(event.target) // サブ担当者の削除用
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    this.renderStaffArea();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderStaffArea();
    this.render();
  }

  @on({ event: 'click', selector: '.add_staff_fields' })
  onClickAddStaffFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.staffs-info').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderStaffArea();
    this.render();
  }

  @on({ event: 'click', selector: '#add_alternative_field' })
  onClickAddAlternativeField() {
    $('#add_alternative_btn').hide();
    $('#alternative_info_modal').modal('hide');
    $('#alternative_field').show();
  }

  @on({ event: 'click', selector: '#remove_alternative_field' })
  onClickRemoveAlternativeField() {
    $('input[name="stakeholder[stockholder_meeting_alternative_email]"]').val(
      '',
    );
    $('#add_alternative_btn').show();
    $('#alternative_field').hide();
  }

  renderAlternativeArea() {
    if (
      $(
        'input[name="stakeholder[stockholder_meeting_alternative_email]"]',
      ).val()?.length === 0
    ) {
      $('#alternative_field').hide();
    } else {
      $('#add_alternative_btn').hide();
      $('#alternative_field').show();
    }
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    // 編集時はdatepickerは存在しない
    if (
      $('.date-field').length &&
      !$(event.target).closest('.date-field').length
    ) {
      $('.date-field').removeClass('focus');

      if (
        $('.date-field')
          .last()
          .val().length === 0
      ) {
        $('.date-field')
          .last()
          .removeClass('form-control-active');
      }
    }
  }

  renderStaffArea() {
    const maxStaffCount = 10;
    if ($('.staff-info:visible').length >= maxStaffCount) {
      $('.add-staff').hide();
      $('#sub-staff-information-icon').hide();
    } else {
      $('.add-staff').show();
      $('#sub-staff-information-icon').show();
    }

    let staffNumber = 1;
    $('.staffs-wrapper')
      .find('.staff-info')
      .each((index, item) => {
        if ($(item).is(':visible')) {
          const staffName = $(item).find('.label-staff-name');
          const iconInfo = $(item).find('.icon-info');

          staffName.text(`サブ担当者${staffNumber}`);
          if (staffNumber === 1) {
            iconInfo.show();
          } else {
            iconInfo.hide();
          }
          staffNumber += 1;
        }
      });
  }

  render() {
    this.initDateRangePicker(this.$el);
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[holder_type]"]:radio',
  })
  onChangeHolderType() {
    const holderType = $('input[name="stakeholder[holder_type]"]')
      .filter(':checked')
      .val();
    this.holderType = holderType;
    this.renderPersonalArea();
  }

  renderPersonalArea() {
    if (this.holderType === 'User') {
      $('.stakeholder_company_name').hide();
      $('.stakeholder_representative_last_name').hide();
      $('.stakeholder_representative_first_name').hide();
      $('.stakeholder_last_name label').html('姓（漢字）');
      $('.stakeholder_first_name label').html('名（漢字）');
      $('.stakeholder_email label').html('メールアドレス');
      $('#stakeholder_last_name').addClass('rounded-top-left');
    } else if (this.holderType === 'Company') {
      $('.stakeholder_company_name').show();
      $('.stakeholder_representative_last_name').show();
      $('.stakeholder_representative_first_name').show();
      $('.stakeholder_last_name label').html('姓（担当者）');
      $('.stakeholder_first_name label').html('名（担当者）');
      $('.stakeholder_email label').html('担当者のメールアドレス');
      $('#stakeholder_last_name').removeClass('rounded-top-left');
    }
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[overseas]"]:radio',
  })
  onChangeIsOverseas() {
    const isOverseas = $('input[name="stakeholder[overseas]"]')
      .filter(':checked')
      .val();
    this.isOverseas = isOverseas === 'true';
    this.hasChangedResidence = true;
    this.renderAddressArea();
  }

  renderAddressArea() {
    if (this.isOverseas) {
      $(
        '#address_button, .stakeholder_prefecture, .stakeholder_city, .stakeholder_address_detail',
      ).hide();
      $('#stakeholder_address').addClass('rounded-bottom');
    } else {
      $(
        '#address_button, .stakeholder_prefecture, .stakeholder_city, .stakeholder_address_detail',
      ).show();
      $('#stakeholder_address').removeClass('rounded-bottom');
    }

    if (this.hasChangedResidence) {
      $(
        '#stakeholder_zip_code, #stakeholder_prefecture, #stakeholder_city, #stakeholder_address, #stakeholder_address_detail',
      ).val('');
      $(
        '#stakeholder_zip_code, #stakeholder_prefecture, #stakeholder_city, #stakeholder_address, #stakeholder_address_detail',
      ).removeClass('form-control-active');
    }
  }

  renderDisabledHolderType() {
    const holderType = $('input[name="stakeholder[holder_type]"]')
      .filter(':checked')
      .val();
    const unSelectedHolderType = $(
      'input[name="stakeholder[holder_type]"]:not(:checked)',
    );
    unSelectedHolderType.prop('disabled', true);
    this.holderType = holderType;
    $('#stakeholder_holder_type_user, #stakeholder_holder_type_company')
      .parent()
      .css({ 'background-color': color.smokeWhite });
  }

  renderDisabled() {
    this.renderDisabledHolderType();
    const unSelectedOverseas = $(
      'input[name="stakeholder[overseas]"]:not(:checked)',
    );
    unSelectedOverseas.prop('disabled', true);
    if (this.holderType === 'User') {
      $('.stakeholder_company_name').hide();
      $('.stakeholder_representative_last_name').hide();
      $('.stakeholder_representative_first_name').hide();
    } else if (this.holderType === 'Company') {
      $('.stakeholder_company_name').show();
      $('.stakeholder_representative_last_name').show();
      $('.stakeholder_representative_first_name').show();
    }
    this.renderAddressArea();

    $(
      `#stakeholder_company_name, #stakeholder_last_name, #stakeholder_first_name,
       #stakeholder_representative_last_name, #stakeholder_representative_first_name,
       #stakeholder_email, #stakeholder_zip_code, #stakeholder_prefecture,
       #stakeholder_city,#stakeholder_address, #stakeholder_address_detail`,
    )
      .prop('disabled', true)
      .addClass('form-control-active');
    $('#stakeholder_overseas_true, #stakeholder_overseas_false')
      .parent()
      .css({ 'background-color': color.smokeWhite });
    $('#select_stakeholder_id').addClass('form-control-active');
    $('#address_button').hide();
    $('#select_stakeholder_id').addClass('form-control-active');
  }
}
